<template>
  <div>
    <v-row>
      <v-col>
        <h3 class="mt-4 mb-0">登録済教室一覧</h3>
        <p class="hint" v-if="!isConfirm && isCancelClassroom">解約を行いたい教室にチェックを入れてください</p>
      </v-col>
    </v-row>
    <v-card class="mb-8">
      <v-data-table
        :headers="headers"
        :items="notCancellingClassromms"
        disable-pagination
        hide-default-footer
        :show-select="isCancelClassroom && !isConfirm"
        item-key="userLogin"
        v-model="selectedClassroomIds"
        mobile-breakpoint=10
      >
      </v-data-table>
    </v-card>

    <!-- 解約対象教室一覧 -->
    <template v-if="isCancelClassroom && isConfirm">
      <v-row>
        <v-col>
          <h3 class="mb-0">解約対象教室一覧</h3>
        </v-col>
      </v-row>
      <v-card class="mb-8">
        <v-data-table
          :headers="headers"
          :items="cancelingClassrooms"
          disable-pagination
          hide-default-footer
          mobile-breakpoint=10
        >
        </v-data-table>
      </v-card>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  components: {
  },

  props: {
    isConfirm: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      headers: [
        { text: 'ログインID', align: 'start', value: 'userLogin', class: 'list-th' },
        { text: '教室名', align: 'center', value: 'name', sortable: false, class: 'list-th' },
        { text: '利用状況', align: 'center', value: 'useStatus', sortable: false, class: 'list-th' },
        { text: '期間', align: 'center', value: 'agreementEndOn', sortable: false, class: 'list-th' },
      ],
    }
  },

  computed: {
    selectedClassroomIds: {
      get () {
        return this.$store.state.enrollment.selectedClassroomIds
      },
      set (value) {
        this.$store.commit('enrollment/setSelectedClassroomIds', {
          selectedClassroomIds: value
        })
      }
    },
    ...mapState('enrollment',[
      'registeredClassrooms',
    ]),
    ...mapGetters('enrollment', [
      'isCancelClassroom'
    ]),
    notCancellingClassromms() {
      return this.registeredClassrooms.filter(rc => rc.useStatus === '利用可能')
    },
    cancelingClassrooms() {
      return this.registeredClassrooms.filter(rc => {
        return this.selectedClassroomIds.map(sc => sc.id).includes(rc.id)
      })
    }
  },
}
</script>

<style lang="stylus" scoped>
.list-th
  font-size: 13px !important
  padding: 0 35px !important
  background-color: #e5e5e5 !important

.list-td
  padding: 0 35px !important

.hint
  font-size 11px
  color #252525
  margin-bottom 5px

</style>
